import React from 'react';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import {
  CourseWorkSubmissionCard,
  ReviewCompleteBadge,
} from '../../molecules/course_work_submissions/CourseWorkSubmissionCard';
import './courseWorkSubmissionListItem.module.scss';
import { ReviewerAssignmentLabel } from '../../molecules/course_work_submissions/ReviewerAssignmentLabel';
import { observer } from 'mobx-react';
import { useViewportState } from '../../../../commonv3/hooks/useViewportState';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { CourseWorkSubmissionIndexView, CourseWorkSubmissionTargetType } from '../../../types/course_work_submissions';
import { SubmissionlinkForUser } from '../../../containers/reviewer/CourseWorkSubmissionListPage';

type Props = {
  submission: CourseWorkSubmissionIndexView;
};

export const submissionCourseWorkType = (submission: CourseWorkSubmissionIndexView) => {
  if (submission.course_work_submission_type === CourseWorkSubmissionTargetType.LESSON_HOMEWORK_SUBMISSION) {
    return 'homework';
  }
  if (submission.course_work_submission_type === CourseWorkSubmissionTargetType.EXAM_PRACTICAL_SECTION_SUBMISSION) {
    return 'exam_practical_section';
  }
};

export const CourseWorkSubmissionListItem = observer(({ submission }: Props) => {
  const { isSp } = useViewportState();
  return (
    <CourseWorkSubmissionCard
      metaAttributes={{
        'data-submission-type': submissionCourseWorkType(submission),
        'data-submission-id': submission.id,
      }}
      badge={submission.review_completed_at && <ReviewCompleteBadge />}
      submissionCreatedAt={submission.created_at}
      onClick={
        isSp
          ? () =>
              GlobalStatesV3.routing.push(
                SubmissionlinkForUser(submission.course_work_submission_type, submission.token)
              )
          : undefined
      }
    >
      <div styleName="body">
        {submission.course_work_submission_type === CourseWorkSubmissionTargetType.LESSON_HOMEWORK_SUBMISSION && (
          <div styleName="header">LESSON {submission.course_work.lesson.index + 1}</div>
        )}
        {submission.course_work_submission_type ===
          CourseWorkSubmissionTargetType.EXAM_PRACTICAL_SECTION_SUBMISSION && (
          <div styleName="header exam_practical_section">実技試験</div>
        )}
        <div styleName="title">{submission.course_work.title}</div>
        <div styleName="description">{submission.course_work.description}</div>
        <div styleName="bottom-tools">
          <ReviewerAssignmentLabel reviewer={submission.reviewer} />
          <Button
            type="normal"
            to={SubmissionlinkForUser(submission.course_work_submission_type, submission.token)}
            styleName="link-button"
            className="link-button"
          >
            提出内容を確認する
          </Button>
        </div>
      </div>
    </CourseWorkSubmissionCard>
  );
});
